import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Filial } from './../persistences/filial';
import { ConfigService } from './config.service';

@Injectable({
	providedIn: 'root'
})
export class FilialService {

	constructor(
		private httpClient: HttpClient,
		private configService: ConfigService,
	) { }

	getFiliais(): Observable<Filial> {
		return this.httpClient.get<Filial>(
			this.configService.getEndereco() + '/cotacao/getFiliais',
			{
				headers: this.configService.getHeaders()				
			}
		)
	}
}
